import { GlobalResponseObject } from "../../global-response-object";
import { CountBySubCategoryGroupDetails } from "./countBySubCategoryGroup-detail";


export class CountBySubCategoryGroupDetailsResponse extends GlobalResponseObject{
data?:CountBySubCategoryGroupDetails[];
constructor(status: boolean, intlCode: number, internalMessage: string, data?:CountBySubCategoryGroupDetails[]){
    super(status,intlCode,internalMessage)
    this.data = data;
}
}